import { MenuItem as MuiMenuItem, Select as MuiSelect, styled } from '@mui/material'

export const MenuItem = styled(MuiMenuItem)`
  padding-bottom: ${({ theme }) => theme.spacing(1.5)};
  padding-top: ${({ theme }) => theme.spacing(1.5)};
`

export const Select = styled(MuiSelect)`
  padding-right: ${({ theme }) => theme.spacing(2)};
`
